module.exports = __webpack_public_path__ + "static/media/readmore.bde40591.svg";